export default __webpack_public_path__ + "static/media/carousel-tma.2d24247d.jpg";